import { supabase } from "../services/supabase";
import { Despesa } from "../types/database";

export function formatarDataLocal(data: Date): string {
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");

  return `${ano}-${mes}-${dia}`;
}

export function parseValorDespesa(valor: string): number {
  const valorNormalizado = valor.trim();
  const separadorDecimal = valorNormalizado.includes(",") ? "," : ".";
  const semSimbolos = valorNormalizado.replace(/[^\d,.-]/g, "");
  const comPontoDecimal = semSimbolos.replace(",", ".");
  const valorSemMilhares =
    separadorDecimal === ","
      ? comPontoDecimal.replace(/\.(?=.*\.)/g, "")
      : comPontoDecimal;
  const valorNumero = Number(valorSemMilhares);

  return Number.isFinite(valorNumero) ? valorNumero : Number.NaN;
}

export const despesasRepository = {
  async criar(
    descricao: string,
    valor: number,
    dataCompra?: string,
  ): Promise<Despesa> {
    const descricaoLimpa = descricao.trim();
    const valorNumero = Number(valor || 0);

    if (!descricaoLimpa) {
      throw new Error("Informe a descrição da despesa.");
    }

    if (!Number.isFinite(valorNumero) || valorNumero <= 0) {
      throw new Error("Informe um valor válido para a despesa.");
    }

    const data = dataCompra ?? formatarDataLocal(new Date());

    const { data: despesa, error } = await supabase
      .from("despesas")
      .insert({
        descricao: descricaoLimpa,
        valor: valorNumero,
        data_compra: data,
      })
      .select()
      .single();

    if (error || !despesa) {
      console.error("Erro ao criar despesa:", error);
      throw new Error(error?.message ?? "Erro ao criar despesa");
    }

    return despesa;
  },

  async listarDoMes(inicioMes: string, fimMes: string): Promise<Despesa[]> {
    const { data, error } = await supabase
      .from("despesas")
      .select("*")
      .gte("data_compra", inicioMes)
      .lte("data_compra", fimMes)
      .order("data_compra", { ascending: false })
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Erro ao listar despesas do mês:", error);
      throw new Error(error.message);
    }

    return data ?? [];
  },

  async listarDoMesAtual(): Promise<Despesa[]> {
    const hoje = new Date();
    const inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    const fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

    return despesasRepository.listarDoMes(
      formatarDataLocal(inicio),
      formatarDataLocal(fim),
    );
  },

  async deletar(id: string): Promise<void> {
    const { error } = await supabase.from("despesas").delete().eq("id", id);

    if (error) {
      console.error("Erro ao excluir despesa:", error);
      throw new Error(error.message);
    }
  },
};
